import { render, staticRenderFns } from "./huanzhe.vue?vue&type=template&id=0e8773f2&scoped=true&"
import script from "./huanzhe.vue?vue&type=script&lang=js&"
export * from "./huanzhe.vue?vue&type=script&lang=js&"
import style0 from "./huanzhe.vue?vue&type=style&index=0&id=0e8773f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8773f2",
  null
  
)

export default component.exports